import { render, staticRenderFns } from "./PSUPaymentTerm.vue?vue&type=template&id=98f9268c&scoped=true&"
import script from "./PSUPaymentTerm.vue?vue&type=script&lang=js&"
export * from "./PSUPaymentTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f9268c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
